// extracted by mini-css-extract-plugin
export default {"colorbar":"Layout_colorbar__YUJ6m","mike":"Layout_mike__A-v5-","colorbarBottom":"Layout_colorbarBottom__nul8i","mainContent":"Layout_mainContent__6OoEY"};